import { BaseAction } from "../../../../core/actions/BaseAction";
import { deleteAccount } from "../../../../app/api/deleteAccount";
import { showNotification } from "../../../../Services/notificationService";
import { getTranslatedMessage } from "../../../../Lib/Utils/i18n";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { invalidateUserCaches } from "../../../LogicActions/MyAccount/invalidateUserCaches";

interface IDeleteAccountParams {
    userId: number;
}

export class DeleteAccountAction extends BaseAction<void, IDeleteAccountParams> {
    override async run(): Promise<void | null> {
        try {
            const { userId } = this.params!;

            if (!userId) {
                console.error("User ID not found.");
                showNotification("error", getTranslatedMessage("errorDeletingAccount", "Error deleting account"), getTranslatedMessage("userIdRequired", "User ID is required"));
                return;
            }

            const response = await deleteAccount(userId);
            
            if (response.status === "ok") {
                showNotification("success", getTranslatedMessage("accountDeletedSuccessfully", "Account deleted successfully"), getTranslatedMessage("accountDeletedDescription", "Your account has been permanently deleted"));
                // Clear user data from recoil state
                updateRecoilState("userDataAtom", null);
                // Also drop the session caches so a later execute() can't replay
                // the just-deleted user back into userDataAtom.
                invalidateUserCaches();
                // Redirect to home or login page could be handled by the component
            } else {
                showNotification("error", getTranslatedMessage("failedToDeleteAccount", "Failed to delete account"), getTranslatedMessage("pleaseTryAgainLater", "Please try again later"));
            }
        } catch (error) {
            console.error("Error in DeleteAccountAction:", error);
            showNotification("error", getTranslatedMessage("errorDeletingAccount", "Error deleting account"), getTranslatedMessage("unexpectedErrorOccurred", "An unexpected error occurred"));
        }
    }
}

export const deleteAccountAction = new DeleteAccountAction(); 